import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from '@emotion/styled';

import PriceBlock from '../../common/PriceBlock';
import PhysicalSetBlock from '../../common/PhysicalSetBlock';
import PriceBlockWithAutoCalc from '../../common/PriceBlockWithAutoCalc';
import VirtualSetBlock from '../../common/VirtualSetBlock';

import TopBlock from '../TopBlock';
import ImagesBlock from '../ImagesBlock';
import PropertiesBlock from '../PropertiesBlock';
import ParametersBlock from '../ParametersBlock';
import VariantsBlock from '../VariantsBlock';
import SubscriptionBlock from '../SubscriptionBlock';
import AdAttachmentsParametersBlock from '../AdAttachmentsParametersBlock';
import ProductChangesBlock from '../ProductChangesBlock';

import Button from '../../../common/Button';

import { preventSubmittingByEnter } from '../../../../helpers';
import MarginSalesBlock from '../../../Settings/MarginSalesBlock';
import { useSelector } from 'react-redux';
import ProductsPriceMarginHistory from '../../ProductsPriceMarginHistory';
import MarginSalesChart from '../../../Summary/MarginSalesChart';

const HeaderWrapper = styled.div`
  padding: 28px 16px 16px;
  margin: 0 -22px;
  position: relative;

  .back-link {
    color: inherit;
    position: absolute;
    font-size: 16px;
    right: 16px;
    top: 15px;
    line-height: 100%;
  }

  .page-title {
    margin: 0 0 5px;
    max-width: calc(100% - 28px);
  }
`;

const FormWrapper = styled('form')`
  margin: 0 -22px;

  > .col-lg-6 {
    padding: 0;
  }

  .header-title {
    margin-bottom: 25px;
  }

  .modal {
    top: 36px;
  }

  .card-box {
    border-radius: unset;
    box-shadow: none;
    padding: 16px;

    > .row {
      margin: 0 -12px;
    }

    .option-row {
      flex-wrap: nowrap;
    }

    .title-block {
      div {
        font-size: 13px !important;
      }
    }

    .input-group {
      .input-group-append button {
        font-size: 0 !important;

        &::before {
          content: '+';
          font-size: 13px;
        }
      }
    }

    .tags-block {
      flex-basis: 50%;
      max-width: 50%;
    }

    .removing-block {
      flex: 16.66667%;
      max-width: unset;

      button {
        padding-left: 0;
      }
    }

    .sortable-wrapper {
      margin: 0 -5px;

      .draggable-source {
        width: calc(50% - 10px);
        height: auto;
        background-size: cover;

        &::before {
          content: '';
          padding-bottom: 100%;
          display: block;
        }
      }

      .dropzone {
        width: calc(50% - 10px);
        height: auto;
      }
    }

    .brand,
    .country {
      flex-basis: 100%;
      max-width: none;
    }

    .attribute-row {
      flex-wrap: wrap;
      align-items: center;
      margin-bottom: 16px;

      .title-block {
        margin-right: auto;
      }

      .removing-block {
        margin-right: 26px;

        i {
          font-size: 16px !important;
        }
      }

      .col-12 {
        width: 100%;
        padding-left: 12px !important;

        .form-group {
          max-width: 100% !important;
        }
      }

      .tags-block {
        order: 1;
        flex-grow: 1;
        max-width: unset;
        flex: unset;
      }
    }

    .add-option-button-row {
      padding: 12px;
    }

    .border-block {
      display: none;
    }

    .variants-buttons {
      margin-bottom: 16px;
    }
  }

  .footer-buttons {
    padding: 0 16px 16px;
    display: flex;
  }

  .dropdown-menu {
    position: absolute;
    will-change: transform;
    bottom: 0;
    top: unset;
    left: 0;
    transform: translate3d(0px, 35px, 0px);

    &.show {
      bottom: 100%;
      top: unset !important;
    }

    .dropdown-item {
      cursor: pointer;
      padding-left: 5px;
      padding-right: 5px;
    }
  }

  .dropdown-toggle {
    border: 1px solid #e3e5e7;
  }

  .border-bottom {
    padding: 0 0 8px;
    margin: 0 0 8px !important;
    border-bottom: 1px solid #e3e5e7;

    .col-12 {
      padding: 0;
    }
  }
`;

const MobileLayout = (props) => {
  const {
    productId,
    pageTitle,
    breadcrumbs,
    isNew,
    currentProduct,
    values,
    errors,
    handleChangeInput,
    images,
    uploadImages,
    reorderImages,
    zoomImage,
    handleDeleteImage,
    useVariants,
    attributes,
    additionalDescsOptions,
    addNewAttribute,
    handleSubmit,
    warehouses,
    handleChangeWeightType,
    loading,
    isSavedVariants,
    needSaving,
    features,
    variants,
    variantsValidation,
    selectedVariants,
    allSelectedVariants,
    appearanceFields,
    handleSelectVariant,
    handleAllSelectVariants,
    options,
    updateVariant,
    deleteVariant,
    deleteLoading,
    addNewFeature,
    dispatch,
    handleShowStockByBatch,
    handleVariantsUsing,
    handleNeedSaving,
    handleSetLastAction,
    handleAddManualVariant,
    setUnsavedStatus,
    openVariant,
    refreshArrearance,
    saveProduct,
    isArchived,
    handleCopy,
    allIsValid,
    handleHideShow,
    handleArchiveItem,
    handleExportMovements,
    unsaved,
    skuSet,
    handleUpdateSkuSet,
    handleCreateSkuSet,
    unSavedSkuSet,
    eshops,
    productMarginDelivered,
    productMarginShipped,
    isSingleProduct,
    isHaveOptionsUsed,
    productsPriceMarginHistory,
    haveProductsPriceMarginHistory,
    openImportChestnyznakModal,
  } = props;

  const [showDropdown, setShowDropdown] = useState(false);

  return (
    <>
      <HeaderWrapper style={{ marginTop: unsaved && 16 }}>
        <h4 className="page-title">{pageTitle}</h4>
        <Link className="back-link" to={breadcrumbs[breadcrumbs.length - 2].route}>
          <i className="fe-x" />
        </Link>
      </HeaderWrapper>
      <FormWrapper onKeyDown={preventSubmittingByEnter} onSubmit={handleSubmit}>
        <div className="row">
          <TopBlock
            isNew={isNew}
            currentProduct={currentProduct}
            values={values}
            errors={errors}
            handleChangeInput={handleChangeInput}
          />
          <ImagesBlock
            images={images}
            onUpload={uploadImages}
            onReorder={reorderImages}
            onItemClick={zoomImage}
            onDelete={handleDeleteImage}
            showHover
            copyImage
            showDefault
            defaultIndex={0}
            dropzoneDescription="Перетащите сюда файлы или кликните для их выбора"
          />
        </div>
        {values.type !== 'SUBSCRIPTION' && values.type !== 'AD_ATTACHMENT' ? (
          <>
            {!useVariants ? (
              <>
                {values.type === 'BUNDLE' ? (
                  <PriceBlockWithAutoCalc
                    currentProduct={currentProduct}
                    values={values}
                    handleChangeInput={handleChangeInput}
                  />
                ) : (
                  <PriceBlock
                    currentProduct={currentProduct}
                    values={values}
                    handleChangeInput={handleChangeInput}
                  />
                )}
                <div className="row">
                  <div className="col-lg-6">
                    <PropertiesBlock
                      values={values}
                      errors={errors}
                      attributes={attributes}
                      additionalDescsOptions={additionalDescsOptions}
                      handleShowStockByBatch={handleShowStockByBatch}
                      handleChangeInput={handleChangeInput}
                      addNewAttribute={addNewAttribute}
                      isNew={isNew}
                      currentProduct={currentProduct}
                    />
                  </div>
                  <ParametersBlock
                    currentProduct={currentProduct}
                    values={values}
                    warehouses={warehouses}
                    errors={errors}
                    handleChangeInput={handleChangeInput}
                    handleChangeWeightType={handleChangeWeightType}
                    handleSubmit={handleSubmit}
                    type={values.type}
                    eshops={eshops}
                  />
                </div>
                {values.type === 'PHYSICAL_SET' ? (
                  <div className="row">
                    <div className="col-12">
                      <PhysicalSetBlock
                        currentProduct={currentProduct}
                        data={unSavedSkuSet ? unSavedSkuSet : skuSet}
                        handleUpdateSkuSet={handleUpdateSkuSet}
                        handleChangeInput={handleChangeInput}
                        needAdditionalData={isNew}
                        isNew={isNew}
                      />
                    </div>
                  </div>
                ) : null}

                {values.type === 'BUNDLE' ? (
                  <div className="row">
                    <div className="col-12">
                      <VirtualSetBlock
                        currentProduct={currentProduct}
                        data={isNew ? unSavedSkuSet : skuSet}
                        handleUpdateSkuSet={handleUpdateSkuSet}
                        handleChangeInput={handleChangeInput}
                        needAdditionalData={isNew}
                        isNew={isNew}
                      />
                    </div>
                  </div>
                ) : null}
              </>
            ) : (
              <>
                <PropertiesBlock
                  values={values}
                  errors={errors}
                  attributes={attributes}
                  handleShowStockByBatch={handleShowStockByBatch}
                  additionalDescsOptions={additionalDescsOptions}
                  handleChangeInput={handleChangeInput}
                  addNewAttribute={addNewAttribute}
                  currentProduct={currentProduct}
                />
              </>
            )}
            {isSingleProduct && !isHaveOptionsUsed ? (
              <div className="card-box">
                <MarginSalesBlock
                  values={values}
                  handleChangeInput={handleChangeInput}
                  productId={productId}
                  variantId={currentProduct?.variants?.[0]?.id}
                />
              </div>
            ) : null}

            {haveProductsPriceMarginHistory && productsPriceMarginHistory?.length > 0 ? (
              <ProductsPriceMarginHistory productsPriceMarginHistory={productsPriceMarginHistory} />
            ) : null}

            {isSingleProduct &&
            !isHaveOptionsUsed &&
            (productMarginShipped || productMarginDelivered) ? (
              <div className="row">
                <MarginSalesChart
                  title="Маржинальность продаж"
                  shipped={productMarginShipped}
                  delivered={productMarginDelivered}
                />
              </div>
            ) : null}

            <div className="card-box">
              <table className="table table-centered">
                <thead className="thead-light">
                  <tr>
                    <th>Наименование</th>
                    <th>Отравление</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <span className="variant-id-span">-</span>
                    </td>
                    <td>
                      <span className="badge">-</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {values.type === 'SKU' ? (
              <VariantsBlock
                loading={loading}
                productId={productId}
                isSavedVariants={isSavedVariants}
                needSaving={needSaving}
                features={features}
                variants={variants}
                variantsValidation={variantsValidation}
                selectedVariants={selectedVariants}
                allSelectedVariants={allSelectedVariants}
                appearanceFields={appearanceFields}
                handleSelectVariant={handleSelectVariant}
                handleAllSelectVariants={handleAllSelectVariants}
                options={options}
                updateVariant={updateVariant}
                deleteVariant={deleteVariant}
                deleteLoading={deleteLoading}
                setOptions={(options) => dispatch({ type: 'setOptions', options })}
                useVariants={useVariants}
                addNewFeature={addNewFeature}
                handleVariantsUsing={handleVariantsUsing}
                handleGenerateVariants={() =>
                  dispatch({
                    type: 'updateGenerateVariantsStatus',
                    needToGenerateVariants: true,
                  })
                }
                handleNeedSaving={handleNeedSaving}
                handleSetLastAction={handleSetLastAction}
                handleAddManualVariant={handleAddManualVariant}
                setUnsavedStatus={setUnsavedStatus}
                openVariant={openVariant}
                refreshArrearance={refreshArrearance}
              />
            ) : null}
            {!isNew ? <ProductChangesBlock productId={productId} loading={loading} /> : null}
          </>
        ) : null}

        {values.type == 'SUBSCRIPTION' ? (
          <SubscriptionBlock
            isNew={isNew}
            currentProduct={currentProduct}
            saveProduct={saveProduct}
          />
        ) : null}

        {values.type == 'AD_ATTACHMENT' ? (
          <div className="row">
            <AdAttachmentsParametersBlock
              currentProduct={currentProduct}
              values={values}
              warehouses={warehouses}
              errors={errors}
              handleChangeInput={handleChangeInput}
              handleChangeWeightType={handleChangeWeightType}
              handleSubmit={handleSubmit}
            />
            <ParametersBlock
              currentProduct={currentProduct}
              values={values}
              warehouses={warehouses}
              errors={errors}
              handleChangeInput={handleChangeInput}
              handleChangeWeightType={handleChangeWeightType}
              handleSubmit={handleSubmit}
              type={values.type}
              eshops={eshops}
            />
          </div>
        ) : null}

        <div className="footer-buttons">
          <Button
            type="submit"
            text="Сохранить"
            disabled={loading || !allIsValid}
            loading={loading === 'main'}
          />
          {!isNew && currentProduct ? (
            <>
              <div style={{ position: `relative` }} className="ml-3">
                <button
                  type="button"
                  className="btn btn-secondary dropdown-toggle"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  onClick={() => setShowDropdown(!showDropdown)}
                >
                  <>
                    Действия
                    <i className="mdi mdi-chevron-up" />
                  </>
                </button>
                <div
                  className={`dropdown-menu ${showDropdown ? `show` : ``}`}
                  onClick={() => setShowDropdown(false)}
                >
                  {!isArchived ? (
                    <>
                      <div className="dropdown-item" onClick={handleCopy}>
                        <i className="fe-copy mr-2" />
                        Копия
                      </div>
                      {isSingleProduct ? (
                        <div className="dropdown-item" onClick={handleHideShow}>
                          <i
                            className={
                              !currentProduct.available ? 'fe-eye mr-2' : 'fe-eye-off mr-2'
                            }
                          />
                          {!currentProduct.available ? 'Отобразить' : 'Скрыть'}
                        </div>
                      ) : null}
                    </>
                  ) : null}
                  {!useVariants ? (
                    <div
                      className="dropdown-item"
                      onClick={() => handleExportMovements(currentProduct.variants[0].id)}
                    >
                      <i className="fe-arrow-down mr-2" />
                      Отчёт о движениях
                    </div>
                  ) : null}
                  <div className="dropdown-item" onClick={() => handleShowStockByBatch(true)}>
                    <i className="fe-arrow-down mr-2" />
                    Отчет об остатках
                  </div>
                  <div className="dropdown-item" onClick={handleArchiveItem}>
                    <i className="fe-archive mr-2" />
                    {!currentProduct.deleted ? 'В архив' : 'Восстановить'}
                  </div>
                  {currentProduct?.type == 'SKU' ||
                  (!skuSet && currentProduct?.type == 'PHYSICAL_SET') ? (
                    <div
                      className="dropdown-item"
                      onClick={() => handleCreateSkuSet('PHYSICAL_SET')}
                    >
                      {' '}
                      {/* TODO add mobile button */}
                      <i className="fe-box mr-2" />
                      Указать состав комплекта
                    </div>
                  ) : null}
                  {currentProduct?.type == 'SKU' ||
                  (!skuSet && currentProduct?.type == 'BUNDLE') ? (
                    <div className="dropdown-item" onClick={() => handleCreateSkuSet('BUNDLE')}>
                      {' '}
                      {/* TODO add mobile button */}
                      <i className="fe-inbox mr-2" />
                      Указать состав виртуального набора
                    </div>
                  ) : null}
                  <div className="dropdown-item" onClick={() => openImportChestnyznakModal()}>
                    <i className="fe-arrow-up mr-2" />
                    Импорт пула номеров «Честный Знак»
                  </div>
                </div>
              </div>
            </>
          ) : null}
        </div>
      </FormWrapper>
    </>
  );
};

export default MobileLayout;
